export default __webpack_public_path__ + "static/media/FirstResumeForSCIC-UpdateOne.4a79cf06.pdf";